import { component as defineComponent } from 'flightjs';

function ShowHidden() {
    this.defaultAttrs({
        'hidden-items': '[data-hidden]',
        button: '[data-show-hidden-button]',
    });

    this.after('initialize', function () {
        this.on('click', {
            button: this.showHiddenItems,
        });
    });

    this.showHiddenItems = function () {
        this.select('hidden-items').removeAttr('data-hidden');
        this.select('button').remove();
    };
}

export default defineComponent(ShowHidden);



// WEBPACK FOOTER //
// ./src/js/component_ui/show-hidden.js